import { routePaths } from "@/shared/config/routePaths";
import { RouteObject } from "react-router-dom";
import { AccessDeniedPage } from "./AccessDeniedPage";
import { NotFoundPage } from "./NotFoundPage";
import { ServiceUnavailablePage } from "./ServiceUnavailablePage";

export const errorsRouter: RouteObject[] = [
    { path: routePaths.errors.accessDenied, element: <AccessDeniedPage /> },
    { path: routePaths.errors.serviceUnavailable, element: <ServiceUnavailablePage /> },
    { path: '*', element: <NotFoundPage /> },
];

